// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header, ion-footer {
  background: var(--ion-white-primary) !important;
}
ion-header ion-title, ion-footer ion-title {
  font-weight: 300;
  font-size: 17px;
  line-height: 25.5px;
}

ion-card {
  background: var(--ion-white-primary);
}

.contentcard {
  padding: 1vw 3vw !important;
}

.headmodalS {
  display: flex;
  width: 100%;
  padding: 4vw 2vw;
  margin: 0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: var(--ion-white-primary) !important;
  border-radius: 0;
}
.headmodalS .titlemodal {
  font-size: 18px;
  font-weight: 400;
  width: 100%;
  text-align: center;
}
.headmodalS ion-icon {
  height: 5vw;
  width: 7.5vw;
  margin: 2vw 2vw;
}

.gen-button {
  height: 7vw;
  display: flex;
  margin: 2vw 2vw;
  padding: 1vw 4vw;
  background-color: var(--ion-color-primary);
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  color: var(--ion-text-primary);
  width: 30%;
}

.close-gen {
  height: 7vw;
  display: flex;
  margin: 2vw 2vw;
  padding: 1vw 4vw;
  background-color: var(--ion-dark-primary);
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  color: var(--ion-text-primary);
  width: 25%;
}

.ogen-button {
  height: 7vw;
  display: flex;
  margin: 2vw 2vw;
  padding: 1vw 4vw;
  background-color: var(--ion-text-primary);
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary);
  width: 30%;
}

.naviB {
  height: 7vw;
  display: flex;
  margin: 0vw 2vw;
  padding: 1vw 4vw;
  background-color: var(--ion-text-primary);
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/terms-and-conditions/terms-and-conditions.page.scss"],"names":[],"mappings":"AAsBA;EACC,+CAAA;AArBD;AAsBC;EACC,gBAAA;EACA,eAAA;EACA,mBAAA;AApBF;;AA2BA;EACC,oCAAA;AAxBD;;AAgCA;EACC,2BAAA;AA7BD;;AA+BA;EACC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;AA5BD;AA8BC;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA5BH;AA8BC;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA5BH;;AA+BE;EACD,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,UAAA;AA5BD;;AA8BE;EACD,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,UAAA;AA3BD;;AA6BE;EACD,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,0CAAA;EACA,UAAA;AA1BD;;AA4BE;EACD,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,0CAAA;AAzBD","sourcesContent":["// ion-header {\n// \tion-title {\n// \t\tfont-weight: 200;\n// \t\tfont-size: 24px;\n// \t\tline-height: 36px;\n// \t}\n// }\n\n// ion-card.contentcard {\n// \tp {\n// \t\tmargin: 0;\n// \t}\n// }\n\n// ion-footer {\n// \tmargin-bottom: 6px;\n\n// \tion-button {\n// \t\tmin-height: 40px;\n// \t}\n// }\n\nion-header,ion-footer {\n\tbackground: var(--ion-white-primary) !important;\n\tion-title {\n\t\tfont-weight: 300;\n\t\tfont-size: 17px;\n\t\tline-height: 25.5px;\n\t}\n}\n\n*{\n\t// color: var(--ion-black-primary);\n}\nion-card{\n\tbackground: var(--ion-white-primary);\n}\n// div{\n// \twidth: 80vw;\n// \tmargin: 0 auto;\n// \tpadding: 2vw;\n// \tbackground: var(--ion-white-primary);\n// }\n.contentcard{\n\tpadding: 1vw 3vw !important;\n}\n.headmodalS{\n\tdisplay: flex;\n\twidth: 100%;\n\tpadding: 4vw 2vw;\n\tmargin: 0;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center;\n\tbackground: var(--ion-white-primary) !important;\n\tborder-radius: 0;\n\t// border: 1px solid var(--ion-diffuseDark-tertiary);\n\t.titlemodal{\n\t  font-size: 18px;\n\t  font-weight: 400;\n\t  width: 100%;\n\t  text-align: center;\n\t}\n\tion-icon{\n\t  height: 5vw;\n\t  width: 7.5vw;\n\t  margin: 2vw 2vw;\n\t}\n  }\n  .gen-button{\n\theight: 7vw;\n\tdisplay: flex;\n\tmargin: 2vw 2vw;\n\tpadding: 1vw 4vw;\n\tbackground-color: var(--ion-color-primary);\n\tborder-radius: 15px;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--ion-text-primary);\n\twidth: 30%;\n  }\n  .close-gen{\n\theight: 7vw;\n\tdisplay: flex;\n\tmargin: 2vw 2vw;\n\tpadding: 1vw 4vw;\n\tbackground-color: var(--ion-dark-primary);\n\tborder-radius: 15px;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--ion-text-primary);\n\twidth: 25%;\n  }\n  .ogen-button{\n\theight: 7vw;\n\tdisplay: flex;\n\tmargin: 2vw 2vw;\n\tpadding: 1vw 4vw;\n\tbackground-color: var(--ion-text-primary);\n\tborder-radius: 15px;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--ion-color-primary);\n\tborder: 1px solid var(--ion-color-primary);\n\twidth: 30%;\n  }\n  .naviB{\n\theight: 7vw;\n\tdisplay: flex;\n\tmargin: 0vw 2vw;\n\tpadding: 1vw 4vw;\n\tbackground-color: var(--ion-text-primary);\n\tborder-radius: 15px;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--ion-color-primary);\n\tborder: 1px solid var(--ion-color-primary);\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
